<si-card class="mb-6 mr-6 block h-[170px] w-[170px] overflow-hidden max-md:mr-0 max-md:h-[95px] max-md:w-full">
    <div
        body
        class="group relative flex h-full flex-col justify-between bg-[var(--si-sys-color-effects-logo)] p-3 text-action-primary-text transition-colors hover:bg-[var(--si-sys-color-text-accent-hover)] max-md:flex-row max-md:items-center max-md:px-5 max-md:py-0"
    >
        <div class="max-w-[70%] text-base text-text-primary font-semibold leading-5 max-md:max-w-[65%] max-md:text-2xl">
            {{ tile.title }}
        </div>

        <button
            type="button"
            class="absolute inset-0 z-20 m-auto hidden h-fit w-fit cursor-pointer items-center justify-center group-hover:flex group-focus-within:flex focus:flex max-md:flex"
            [attr.aria-label]="'accessibility.open-tile-details' | translate: { title: tile.title }"
            (click)="showTileInfo()"
        >
            <si-icon class="si-display-xl" icon="element-info" />
        </button>

        @if (tile.canDownload) {
            <button
                type="button"
                class="absolute bottom-2 right-2 z-10 btn btn-icon btn-tertiary-ghost element-download"
                [attr.aria-label]="'accessibility.download-tile' | translate: { title: tile.title }"
                (click)="downloadFile()"
            ></button>
        }
    </div>
</si-card>
